import Marquee from "react-fast-marquee";
import { MARQUEE } from "../data";

export const MarqueeBar = () => (
  <div className="border-t border-b border-zinc-800 py-6 bg-[#0A0A0A]" data-testid="marquee">
    <Marquee speed={45} gradient={false} autoFill>
      {MARQUEE.map((word, i) => (
        <span key={i} className="font-display text-4xl md:text-6xl text-zinc-800 mx-8 flex items-center gap-8">
          {word}
          <span className="text-[#FF3B30] text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
